<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='titleIcon'
      :showAdd='!estimate.is_sold'
      @add='addLine'
    >
      <v-simple-table dense>
        <tbody>
          <tr v-if='lines.length === 0'>
            <td colspan='2' class='grey--text'>Nothing added</td>
          </tr>

          <line-item
            v-for='(l, index) in sortedItems'
            @lineClick='editLine'
            hideSortUp
            hideSortDown
            @deleteLine='confirmDelete(l)'
            :key='l.id'
            :line='l'
            :isLast='index === (lines.length - 1)'
          ></line-item>
        </tbody>
      </v-simple-table>
    </wc-data-box>
    <line-item-dialog
      :line='lineCopy'
      :title='title'
      :titleIcon='titleIcon'
      :estimate='estimate'
      :showDialog='showEditLine'
      :isSavingLine='isSavingLine'
      @cancel='cancelEdit'
      @save='saveLine'
    ></line-item-dialog>

    <wc-dialog
      :showDialog='showConfirmDelete'
      title='Are you sure?'
      icon='mdi-alert'
      iconColor='red'
      @cancel='showConfirmDelete = false'
      saveText='Yes, Remove'
      :loadingButtons='isSavingLine'
      @save='deleteLine'
    >
      Are you sure you want to remove this line item?<br>
      <br>
      <strong>{{ lineCopy.description }}</strong><br>
      <span v-html='lineCopy.notes'></span>
      <template v-slot:dialog-actions>
        <v-btn text color='orange' @click='showHelp = true'>Help</v-btn>
      </template>
    </wc-dialog>

    <wc-help :showHelp='showHelp' @closeHelp='showHelp = false'>
      Removing this item will only remove it from this estimate and will not affect any other records.
    </wc-help>
  </div>
</template>

<script>
import Line from '@/modules/estimates/components/Line'
import LineItemDialog from '@/modules/estimates/components/LineItemDialog'
import estimateLinesAPI from '@/modules/estimates/api/estimateLineItems'
import assets from '@/modules/assets/api/inventory'
import misc from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'estimate-line-items',
  props: {
    estimate: {
      required: true
    },
    optional: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    isSavingLine: false,
    showEditLine: false,
    showConfirmDelete: false,
    showHelp: false,
    lines: [],
    lineCopy: {}
  }),
  created () {
    this.getLines()
    this.getInventory()
  },
  computed: {
    sortedItems () {
      if (this.lines.length > 0) {
        return this.lines
      }
      return []
    },
    title () {
      return this.optional
        ? 'Optional Items'
        : 'Line Items'
    },
    titleIcon () {
      return this.optional
        ? 'mdi-format-list-checkbox'
        : 'mdi-format-list-bulleted-square'
    }
  },
  methods: {
    async getLines () {
      this.isLoading = true
      this.lines = this.optional
        ? await estimateLinesAPI.getOptionalLineItems(this.estimate.id)
        : await estimateLinesAPI.getEstimateLineItems(this.estimate.id)
      this.isLoading = false
    },
    async getInventory () {
      this.inventory = await assets.getInventoryForDivision(this.estimate.division)
    },
    editLine (l) {
      this.lineCopy = _.cloneDeep(l)
      this.showEditLine = true
    },
    addLine () {
      this.lineCopy = {}
      this.showEditLine = true
    },
    cancelEdit () {
      this.showEditLine = false
    },
    confirmDelete (line) {
      this.lineCopy = _.cloneDeep(line)
      this.showConfirmDelete = true
    },
    async deleteLine () {
      this.isSavingLine = true
      this.lines = await estimateLinesAPI.deleteLineItem(this.lineCopy, this.lines)
      this.showConfirmDelete = false
      this.isSavingLine = false
    },
    // async sortItemUp (l) {
    //   this.lines = await estimateLinesAPI.sortItemUp(l, this.lines)
    // },
    // async sortItemDown (l) {
    //   this.lines = await estimateLinesAPI.sortItemDown(l, this.lines)
    // },
    async saveLine (line) {
      // line is coming from the LineItemDialog component
      this.isSavingLine = true
      line.is_optional = this.optional
      if (line.id) {
        const tmp = await estimateLinesAPI.updateEstimateLineItem(line)
        this.lines = misc.replaceObject(this.lines, tmp)
      } else {
        line.estimate = this.$route.params.id
        const tmp = await estimateLinesAPI.createEstimateLineItem(line)
        this.lines.push(tmp)
      }
      this.showEditLine = false
      this.isSavingLine = false
    }
  },
  components: {
    'line-item': Line,
    'line-item-dialog': LineItemDialog
  }
}
</script>
